import { apiGet } from "../ApiMethod";
import { setCampusData } from "../../mappers";

export const getCampusById = async (id, cancelToken = null) => {
  const response = await apiGet("_campuses", {}, id, cancelToken);
  return { ...response, data: setCampusData(response.data) };
};
